
import { getLocationTargetingStyles } from '@bingads-webui-campaign-react/location-targeting';
import { useResponsiveStyleWrapper } from '@bingads-webui-campaign-react/unified-app-shared';

const getStyles = () => ({
  container: {
    maxWidth: 680,
  },
  ...getLocationTargetingStyles(),
});

export const useTargetingStepStyles = () => useResponsiveStyleWrapper(getStyles);
